/** Shared Google Maps loader config — keep libraries in sync across map surfaces. */
export const GOOGLE_MAPS_LIBRARIES = ["places", "geometry"];

export const GOOGLE_MAPS_SCRIPT_ID = "attunelogic-google-maps";

/**
 * Resolve the Google Maps API key from tenant config with local env fallbacks.
 * @param {object | undefined} configs
 * @returns {string}
 */
export function resolveGoogleMapsApiKey(configs) {
  return (
    configs?.googleMapsApiKey ||
    import.meta.env.VITE_GOOGLE_MAPS_API_KEY ||
    import.meta.env.VITE_GOOGLE_API_KEY ||
    import.meta.env.VITE_GOOGLE_KEY ||
    ""
  );
}
